import React from "react";

export function IconClose(props) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.05396 6L11.179 2.875C11.5852 2.5 11.5852 1.875 11.179 1.5L10.4915 0.8125C10.1165 0.40625 9.49146 0.40625 9.11646 0.8125L5.99146 3.9375L2.83521 0.8125C2.46021 0.40625 1.83521 0.40625 1.46021 0.8125L0.772705 1.5C0.366455 1.875 0.366455 2.5 0.772705 2.875L3.89771 6L0.772705 9.15625C0.366455 9.53125 0.366455 10.1562 0.772705 10.5312L1.46021 11.2188C1.83521 11.625 2.46021 11.625 2.83521 11.2188L5.99146 8.09375L9.11646 11.2188C9.49146 11.625 10.1165 11.625 10.4915 11.2188L11.179 10.5312C11.5852 10.1562 11.5852 9.53125 11.179 9.15625L8.05396 6Z" fill="currentColor"/>
    </svg>
  );
}